<template>
    <div class="col-12">

        <div v-show="makePaymentElement">
            <div class=" row text-center m-5">
                <h3 v-if="success" class="ui inverted purple text"> <strong> {{ title }}</strong>
                </h3>
                <h3 v-if="!success" class="ui inverted purple text"><strong> {{ title
                }}</strong>
                </h3>

            </div>
            <div class="row d-flex justify-content-center align-items-center mt-5">
                <div class="col-11 col-lg-9">
                    <div class="ui violet floating message m-4">
                        <div class="header mb-2">
                            <div v-if="loadingRequest" class="ui active inline loader"></div>
                            {{ subTitle }}
                        </div>
                        <p> {{ message }}</p>
                    </div>
                    <button v-if="retryButton && !submitDocumentsLater" class="ui button large basic  purple fluid mt-4 mb-4"
                        @click="startPayment()">Retry
                        Payment</button>
                    <button v-if="retryButton && submitDocumentsLater" class="ui button large basic purple fluid mt-4 mb-4"
                        @click="submitDocsLater()">Retry @
                        Payment</button>
                    <button v-if="logoutButton" class="ui button  grey fluid mt-4 mb-4" @click="login()">Logout</button>

                </div>
            </div>
        </div>


    </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";
import { URLS } from "@/utils/constants";
import { useAuthStore } from '@/stores/auth';
import { useCustomerStore } from '@/stores/customer';
import { useAccountOpeningStore } from '@/stores/accountOpening';
import { clearPersistedState } from '@/stores';

export default {
    name: "Payment",
    setup() {
        const authStore = useAuthStore();
        const customerStore = useCustomerStore();
        const accountOpeningStore = useAccountOpeningStore();
        return { authStore, customerStore, accountOpeningStore };
    },
    data() {
        return {
            makePaymentElement: true,
            accounts: [],
            subTitle: '',
            title: '',
            message: '',
            missingFile: '',
            success: true,
            retryButton: false,
            loadingRequest: true,
            isChecked: false,
            submitDocumentsLater: false,
            logoutButton: false,
            uploadDocumentsElement: false,
            customer: {
                mobileNumber: '',
                email: '',
                title: '',
                firstName: '',
                lastName: '',
                idNumber: '',
                gender: '',
                street: '',
                branch: '',
                town: '',
                currency: '',
                dateOfBirth: '',
                lineOfBusiness: '',
                sourceOfIncome: '',
                monthlyIncomeAmount: '',
                activityExpectedOnAccount: '',
                signature: null,
                customerUid: '',
                accountType: '',
                status: 'PENDING',
                userId: '',
                requestType: "PROCESS_CURRENT_ACCOUNT",
            },
        };
    },
    computed: {
        phone() { return this.authStore.phone; },
        userId() { return this.authStore.userId; },
        customerDetails() { return this.customerStore.customerDetails; },
        preAccountType() { return this.accountOpeningStore.preAccountType; },
        currencyType() { return this.accountOpeningStore.currencyType; },
        signature() { return this.accountOpeningStore.signature; },
    },
    created() {
        // Initialize customer data from Vuex store
        this.customer.mobileNumber = this.phone;
        this.customer.email = this.customerDetails.email;
        this.customer.title = this.customerDetails.title;
        this.customer.firstName = this.customerDetails.firstName;
        this.customer.lastName = this.customerDetails.lastName;
        this.customer.idNumber = this.customerDetails.identityDocNo;
        this.customer.gender = this.customerDetails.gender;
        this.customer.street = this.customerDetails.street;
        this.customer.branch = this.customerDetails.branch;
        this.customer.town = this.customerDetails.town;
        this.customer.currency = this.currencyType;
        this.customer.dateOfBirth = this.customerDetails.dateOfBirth;
        this.customer.lineOfBusiness = this.customerDetails.lineOfBusiness;
        this.customer.sourceOfIncome = this.customerDetails.sourceOfIncome;
        this.customer.monthlyIncomeAmount = this.customerDetails.monthlyIncomeAmount;
        this.customer.activityExpectedOnAccount = this.customerDetails.activityExpectedOnAccount;
        this.customer.signature = this.signature;
        this.customer.accountType = this.preAccountType;
        this.customer.userId = this.userId;
    },
    mounted() {
        this.startPayment();
    },
    methods: {
        login() {
            this.$router.push("/omni");
        },
        startPayment() {
            this.setDefaults();

            // Re-read from store in case persisted state hydrated after created()
            this.customer.accountType = this.preAccountType;

            this.postNoAuthAndNoBaseUrl(
                URLS.processAccount,
                this.customer,
                "Customer Data Uploaded",
                null,
                true
            ).then((res) => {
                if (!res) return;
                if (res.errors) return (this.errors = res.errors);
                if (res.body.status === "COMPLETE") {
                this.title = 'Complete';
                this.message = 'Your application has been submitted successfully. Once authorized, your account number will be sent to you via SMS. Thank you for choosing TN CyberTech Bank!';
                this.subTitle = 'TN CyberTech Bank';
                this.success = true;
                this.logoutButton = true;
                this.loadingRequest = false;
                // Clear all state after successful submission
                this.resetAllState();

                } else {
                    if (res.body.requestType === "ECOCASH_DEPOSIT") {
                        this.title = 'Sorry, Payment Authorization Failed'
                        this.success = false;
                        this.message = 'Click the button below to retry the payment process.';
                        this.retryButton = true;
                        this.logoutButton = true;
                        this.loadingRequest = false;

                    }
                    this.title = 'Very Sorry, An Error Has Occurred'
                    this.success = false;
                    this.message = 'Click the button below to retry the payment process. If the error persists, please contact us for assistance.';
                    this.retryButton = true;
                    this.logoutButton = true;
                    this.loadingRequest = false;

                }
            });
        },

        setDefaults() {

            this.message = 'In approximately 10 seconds you will be asked to enter your EcoCash PIN  on your mobile phone to facilitate the account opening fee. This will enable us to co that we can accept your account opening request.';
            this.title = 'Almost Done!';
            this.subTitle = 'Pending Ecocash Payment Authorization';
            this.success = true;
            this.retryButton = false;
            this.logoutButton = false;
            this.loadingRequest = true;
        },
        resetAllState() {
            this.authStore.$reset();
            this.customerStore.$reset();
            this.accountOpeningStore.$reset();
            clearPersistedState();
        },
        ...baseMethods,
    }
};
</script>